// Installs the google.maps.drawing polyfill, then signals that the Maps API is
// ready.
//
// Google deprecated google.maps.drawing in Aug 2025. As of Maps JS 3.65 the real
// DrawingManager constructor emits an unconditional console.error and carries a
// throw gated behind an internal Google-controlled flag, so it can stop working
// without a deploy on our side. We ship our own instead.
//
//   Upstream : https://github.com/mapchannels/mcx-drawing-polyfill
//   Pinned   : 3c34b8908f5e5303e0178b8b484e7636f2a983cf (vendored 2026-08-26)
//   License  : MIT, see vendor/assets/javascripts/mcx-drawing-polyfill.LICENSE
//
// Script URLs come from gon.mcx_drawing_urls (set in lib/app/gon_helper.rb)
// because the vendored assets are digested in production.
//
// Two things that will silently break this if changed:
//
//   1. The base polyfill no-ops if google.maps.drawing already exists. Google
//      still serves that namespace, so `libraries=drawing` must stay out of the
//      Maps bootstrap URL in app/views/layouts/*.html.slim.
//   2. mcx-drawing-shapes.js is required, not optional. The base file only ships
//      marker/polyline/polygon; the locations map view also needs circle and
//      rectangle. It must load after the base file.
//
// These are injected at runtime rather than bundled into application.js on
// purpose: the polyfill's IIFE runs `window.google.maps = window.google.maps ||
// {}` at parse time, and in the bundle that stub would make the
// `typeof google.maps == 'object'` guard in company/locations/mapview.coffee
// pass before the real API exists.

(function () {
  var pending = null;

  function sources() {
    return (window.gon && gon.mcx_drawing_urls) || [];
  }

  function inject(urls, done) {
    var i = 0;
    (function next() {
      if (i >= urls.length) { done(); return; }
      var script = document.createElement('script');
      script.src = urls[i++];
      script.async = false;
      script.onload = next;
      script.onerror = function () {
        // Leave google.maps.drawing undefined rather than half-installed; the
        // caller still runs so the rest of the map keeps working.
        console.error('[MCX] failed to load drawing polyfill: ' + script.src);
        next();
      };
      document.head.appendChild(script);
    })();
  }

  // Runs `callback` once google.maps.drawing.DrawingManager is available.
  // Idempotent: concurrent callers share one injection, and later calls resolve
  // synchronously once the namespace is present.
  window.mcxDrawingReady = function (callback) {
    var maps = window.google && window.google.maps;
    if (maps && maps.drawing && maps.drawing.DrawingManager) { callback(); return; }

    var urls = sources();
    if (!urls.length) {
      console.error('[MCX] gon.mcx_drawing_urls is missing; drawing tools unavailable.');
      callback();
      return;
    }

    if (!pending) {
      pending = [];
      inject(urls, function () {
        var queued = pending;
        pending = 'done';
        for (var i = 0; i < queued.length; i++) { queued[i](); }
      });
    }
    if (pending === 'done') { callback(); } else { pending.push(callback); }
  };

  function googleMapsCallbackFunction() {
    window.mcxDrawingReady(function () {
      window.dispatchEvent(new CustomEvent('googleMapsAPI:loaded', { bubbles: true }));
    });
  }

  window.googleMapsCallbackFunction = googleMapsCallbackFunction;
})();
